import { Component } from '@opten/compiler/metadata/component';

@Component({ className: 'js-previous-after-slider' })
export class PreviousAfterSliderComponent {
	private swiper: Swiper;

	constructor(public element: HTMLElement) {
		this.swiper = new Swiper(this.element, {
			speed: 600,
			navigation: {
				nextEl: this.element.querySelector('.swiper-button-next') as HTMLElement,
				prevEl: this.element.querySelector('.swiper-button-prev') as HTMLElement
			},
			allowTouchMove: false,
			keyboard: true,
			loop: true
		});
	}
}
